import { updates } from "@/mocks/homeContent";

const kindStyle: Record<string, string> = {
  入口: "bg-primary-500",
  同步: "bg-accent-500",
  维护: "bg-secondary-400",
};

export default function UpdateLog() {
  return (
    <section id="updates" className="border-y border-secondary-200/70 bg-background-100/50 py-12 md:py-16">
      <div className="mx-auto w-full max-w-3xl px-4 md:px-6">
        <div className="flex items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-history-fill text-lg leading-none"></i>
          </span>
          <div>
            <h2 className="font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-3xl">
              更新动态
            </h2>
            <p className="text-xs text-foreground-500">换址与功能上线记录，追瓜更新通知第一时间掌握。</p>
          </div>
        </div>

        {/* 时间线 */}
        <div className="relative mt-8">
          <span className="absolute bottom-6 left-[14px] top-6 w-px bg-secondary-200"></span>
          {updates.map((u) => (
            <div key={u.id} className="relative mb-6 pl-10 last:mb-0">
              <span
                className={`absolute left-[7px] top-1.5 flex h-3.5 w-3.5 items-center justify-center rounded-full ${kindStyle[u.kind]}`}
              ></span>
              <div className="rounded-2xl border border-secondary-200/70 bg-background-50 p-4 md:p-5">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="font-display text-sm tracking-wide text-foreground-400">{u.date}</span>
                  <span
                    className={`rounded px-2 py-0.5 text-[11px] font-semibold text-background-50 ${kindStyle[u.kind]}`}
                  >
                    {u.kind}
                  </span>
                  <h3 className="text-sm font-bold text-foreground-950 md:text-base">{u.title}</h3>
                </div>
                <p className="mt-2 text-sm leading-6 text-foreground-600">{u.note}</p>
              </div>
            </div>
          ))}
        </div>

        <p className="mt-2 rounded-xl border border-accent-200/70 bg-accent-100/50 px-4 py-3 text-center text-xs leading-5 text-accent-900">
          换地址期间请以「本页 + 官方渠道」双校验为准，谨防冒用「吃瓜网址新地址」的仿站。
        </p>
      </div>
    </section>
  );
}